import React, { Component } from 'react';
import PropTypes from 'prop-types';

class NumericalOptions extends Component {

    render() { 
        const start = parseInt(this.props.start, 0);
        const end = parseInt(this.props.end, 0);
        let options = [];
        if (this.props.unlimited === "true") {
            options.push("Unlimited");
        }
        for (let i = start; i <= end; i++) {
            options.push(i);
        }
        return ( 
            options.map((option, i) => <option key={i} value={option === "Unlimited" ? 1000 : option}>{option}</option>)
        )
    }
}

NumericalOptions.propTypes = {
    start: PropTypes.string,
    end: PropTypes.string,
    unlimited: PropTypes.string
}
 
export default NumericalOptions;


// WEBPACK FOOTER //
// ./src/components/Common/NumericalOptions/NumericalOptions.js